import { render } from "./RoomReactionEdit.vue?vue&type=template&id=28ef6ee6&ts=true"
import script from "./RoomReactionEdit.vue?vue&type=script&lang=ts"
export * from "./RoomReactionEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__